"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SectorLocation$ = exports.SectorLocation$outboundSchema = exports.SectorLocation$inboundSchema = void 0;
exports.sectorLocationToJSON = sectorLocationToJSON;
exports.sectorLocationFromJSON = sectorLocationFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
const sectorlocationwrapper_js_1 = require("./sectorlocationwrapper.js");
/** @internal */
exports.SectorLocation$inboundSchema = z.object({
    data: sectorlocationwrapper_js_1.SectorLocationWrapper$inboundSchema,
});
/** @internal */
exports.SectorLocation$outboundSchema = z.object({
    data: sectorlocationwrapper_js_1.SectorLocationWrapper$outboundSchema,
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var SectorLocation$;
(function (SectorLocation$) {
    /** @deprecated use `SectorLocation$inboundSchema` instead. */
    SectorLocation$.inboundSchema = exports.SectorLocation$inboundSchema;
    /** @deprecated use `SectorLocation$outboundSchema` instead. */
    SectorLocation$.outboundSchema = exports.SectorLocation$outboundSchema;
})(SectorLocation$ || (exports.SectorLocation$ = SectorLocation$ = {}));
function sectorLocationToJSON(sectorLocation) {
    return JSON.stringify(exports.SectorLocation$outboundSchema.parse(sectorLocation));
}
function sectorLocationFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.SectorLocation$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'SectorLocation' from JSON`);
}
//# sourceMappingURL=sectorlocation.js.map